// Parse the API's `updated_at` ("DD-MM-YYYY HH:mm:ss", optionally with
// ".SSSSSS" / "Z" suffix) into a sortable epoch. Done manually rather than via
// moment so the util is deterministic AND unit-testable (moment is mocked to a
// constant in the Jest suite, which would make any date sort meaningless).
export const toMillis = (value) => {
    if (!value || typeof value !== 'string') return 0;
    const m = value.match(/^(\d{2})-(\d{2})-(\d{4})[ T](\d{2}):(\d{2}):(\d{2})/);
    if (!m) return 0;
    const [, dd, mo, yyyy, hh, mi, ss] = m;
    return Date.UTC(Number(yyyy), Number(mo) - 1, Number(dd), Number(hh), Number(mi), Number(ss));
};

// PRODUCT DECISION (Plan 1 — preserve current OverView behaviour, OverView.jsx finalTreatmentArray):
// A CLOSED treatment is selectable ONLY when the lead has <= 3 treatments total.
// With > 3 treatments, CLOSED treatments are hidden from the selector (still
// inspectable in the Treatments tab). Revisit in a later plan if users need to
// act on historical/closed treatments from the Overview.
export const getSelectableTreatments = (leadDetail) => {
    const treatments = leadDetail?.lead_treatments;
    if (!Array.isArray(treatments) || treatments.length === 0) return [];
    const includeClosed = treatments.length <= 3;
    return treatments
        .filter((treatment) => includeClosed || treatment?.status !== 'CLOSED')
        .slice()
        // Active (non-CLOSED) treatments always rank before CLOSED ones, THEN newest
        // updated_at. Sorting by updated_at alone made the default active treatment the
        // OLD completed row whenever it was closed after the new round was created (e.g.
        // a fresh "Composite Bonding" started while the previous one is being wrapped up)
        // — follow-up CTAs then targeted the completed treatment. A CLOSED treatment is
        // still reachable via an explicit ?treatmentId= (resolveActiveTreatment matches it).
        .sort((a, b) => {
            const aClosed = a?.status === 'CLOSED' ? 1 : 0;
            const bClosed = b?.status === 'CLOSED' ? 1 : 0;
            if (aClosed !== bClosed) return aClosed - bClosed;
            return toMillis(b?.updated_at) - toMillis(a?.updated_at);
        });
};

export const resolveActiveTreatment = (leadDetail, activeTreatmentId) => {
    const selectable = getSelectableTreatments(leadDetail);
    if (selectable.length === 0) return null;
    if (activeTreatmentId != null) {
        const match = selectable.find((treatment) => String(treatment?.id) === String(activeTreatmentId));
        if (match) return match;
    }
    return selectable[0];
};

export const getValidActiveTreatmentId = (leadDetail, requestedId) => {
    const active = resolveActiveTreatment(leadDetail, requestedId);
    return active?.id ?? null;
};
